import React from "react";
import styled, { css } from "styled-components";
import cx from "classnames";
import { InputLabel } from "../inputLabel";
import { focusWell } from "../../focusWell";
import { inputHighlighting } from "../../../utils/helpers/inputHighlighting";
import { InputWrapper } from "../inputWrapper";
import { ValidationMessage } from "../validationMessage";

export const StyledSelect = styled.select(({ theme }) => css`
  ${focusWell({hollow: true})}
  display: block;
  font-size: 16px;
  font-weight: ${theme.fonts.headingWeight};
  padding: 15px 45px 15px 24px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath d='M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 17px top 50%;
  background-size: 14px auto;

  @media only screen and (min-width: ${theme.breakpoints.XM}) {
    background-position: right 30px top 50%;
  }

  ${inputHighlighting()}

  option {
    font-weight: normal;
  }
  
  &:disabled, &[aria-disabled=true] {
    color: graytext;
  }

  &:disabled:hover, &[aria-disabled=true] {
    border-color: #aaa;
  }
`);

export const Select = (props) => {
  const {
    title, placeholder, onChange, onBlur, value, options, name, prefix, toolTipText, className, errorMessage
  } = props;

  const hasError = !!errorMessage;

  return (
    <InputWrapper className={className} name={name}>
      <InputLabel name={name} toolTipText={toolTipText} title={title} />
      <StyledSelect
        className={cx({ "has-error": hasError, valid: !hasError && !!value })}
        onChange={onChange}
        onBlur={onBlur}
        value={value || ""}
        name={name}
        aria-label={title}
        data-prefix={prefix}
      >
        {!!placeholder && <option value="">{placeholder}</option>}
        {(options || []).map((item, index) => (
          <option
            key={`option-${index}`}
            value={item.value}
          >
            {item.label}
          </option>
        ))}
      </StyledSelect>
      <ValidationMessage errorMessage={errorMessage} />
    </InputWrapper>
  )
}